"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KeySystemRootKeyStorageMode = void 0;
var KeySystemRootKeyStorageMode;
(function (KeySystemRootKeyStorageMode) {
    KeySystemRootKeyStorageMode["Synced"] = "synced";
    KeySystemRootKeyStorageMode["Local"] = "local";
    KeySystemRootKeyStorageMode["Ephemeral"] = "ephemeral";
})(KeySystemRootKeyStorageMode || (exports.KeySystemRootKeyStorageMode = KeySystemRootKeyStorageMode = {}));
